import { useEffect } from 'react'
import { Map as OLMap } from 'ol'
import { OpenLayersBaseMap } from '../../../../types'
import { addGeolocationLayer } from '../../utils/geolocationLayer'

type UseLayersUpdateProps = {
  mapInstance: React.MutableRefObject<OLMap | null>
  baseLayerSourceName: OpenLayersBaseMap
  createBaseLayer: () => any
  geolocation: {
    active: boolean
    opacity: number
  }
}

export function useLayersUpdate({
  mapInstance,
  baseLayerSourceName,
  createBaseLayer,
  geolocation,
}: UseLayersUpdateProps) {
  useEffect(() => {
    const map = mapInstance.current
    if (!map) return

    const layers = map.getLayers().getArray()

    // Atualiza camada base
    const baseLayer = layers.find((layer) => layer.get('name') === 'BASE_MAP')
    if (baseLayer?.get('sourceName') !== baseLayerSourceName) {
      if (baseLayer) {
        map.removeLayer(baseLayer)
      }
      const newBaseLayer = createBaseLayer()
      newBaseLayer.set('name', 'BASE_MAP')
      newBaseLayer.set('sourceName', baseLayerSourceName)
      newBaseLayer.setZIndex(0)
      map.addLayer(newBaseLayer)
    }

    // Atualiza camada de geolocalização
    const geoLayer = layers.find((layer) => layer.get('name') === 'MY_LOCATION')

    if (geolocation.active) {
      if (!geoLayer) {
        addGeolocationLayer(map)
      } else {
        geoLayer.setOpacity(geolocation.opacity)
      }
    } else {
      if (geoLayer) {
        map.removeLayer(geoLayer)
      }
    }
  }, [mapInstance, baseLayerSourceName, createBaseLayer, geolocation])
}
